export enum BrowserStorageType {
    Local
}

export enum BrowserStorageKey {
    Token,
    ActiveBook,
    User
}